import React from 'react'
import {useIntl} from 'react-intl'
import {Image, Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {getUrl} from '../../utils/cloudinary-utils'
import {useStoreContext} from '../../contexts/store'

const FindStore = () => {
    const intl = useIntl()
    const {store, onOpen, isLoading} = useStoreContext()

    return (
        <Button
            onClick={onOpen}
            isLoading={isLoading}
            className="store-icon"
            variant="unstyled"
            position="static"
            display="flex"
            fontWeight="300"
            fontSize="14px"
            width="fit-content"
            height="fit-content"
            _hover={{textDecoration: 'none'}}
            color="black.100"
            gap="0.8rem"
        >
            <Image
                alt="Store Icon"
                width="13px"
                height="21px"
                src={getUrl('UIImages/images/store-locator-icon.svg')}
            />
            {store && store.name ? (
                <Text as="span" textTransform="capitalize">
                    {store.name.toLowerCase()}
                </Text>
            ) : (
                intl.formatMessage({
                    id: 'find.a.store',
                    defaultMessage: 'Find a Store'
                })
            )}
        </Button>
    )
}

export default FindStore
